angular.module('mtic.components.dashboards.student_general')
.directive('studentClass', function (
  $http,
  $log,
  $q,
  EventManager,
  language,
  userAccount,
  api,
  DATA_HOST,
  PanelFactory,
  PlatformService,
  StudentDataService,
  TeacherDataService,
  $timeout,
  $rootScope)
{
  return {
    templateUrl: 'template.html',
    scope: {},
    link: function (scope, element) {

      var eventManager = new EventManager('studentClass', scope);
      var redirect_class = null;
      scope.isMobile = (navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent));

      scope.loadingStatus = {
          reset: function(){
            this.done = false;
            this.failed = false;
          },
          okay: function(){
            this.done = true;
            this.failed = false;
          },
          error: function(error){
            $log.error(error)
            this.done = true;
            this.failed = error || true;
          },
          done: false,
          failed: false,
      }

      scope.fullName = function(){
        return userAccount.getData().fullName
      }
      scope.userId = function(){
        return userAccount.getData().user_id
      }

      scope.flags = {
        accountsV2: false,
        accountsV1: false
      }
      $rootScope.sidebarExpanded = (PlatformService.isPhonePortrait() ? false : true);

      eventManager.listen('student:toggle:Sidepanel', function(e, val){
        $rootScope.sidebarExpanded = val;
      })

      $rootScope.$watch('sidebarExpanded', function(val){
        eventManager.broadcast('sidepanel:toggled', val);
      })

      StudentDataService.getClasses()
        .then(function(classes){
          scope.classes = classes;
          scope.selectedClass = scope.classes[0];
          if (userAccount.getActiveClassroom()){
            _.each(scope.classes, function(classroom){
              if (classroom.id === userAccount.getActiveClassroom()){
                scope.selectedClass = classroom;
              }
              classroom.fullname = classroom.resource_type + ' - ' + classroom.name;
              classroom.code = TeacherDataService.renderClassCodeStr(classroom);
            })
          }
          eventManager.broadcast('student:selectClass', scope.selectedClass)
        });

      eventManager.listen('student:selectClass', function(e, classroom) {
        scope.loadingStatus.reset();
        userAccount.setActiveClassFull(classroom);
        var studentPages = [{id: 'modules', name: 'Modules'}];
        if($rootScope.isOCMT){
          studentPages.push({id: 'dashboard', name: 'Dashboard'})
        }
        $q.all([
          PanelFactory.setupOrUpdateScopedMenu(scope, studentPages)
        ]).then(function(){
          scope.loadingStatus.okay();
          scope.nav.setSelection('modules')
        }).catch(function(error){
          scope.loadingStatus.error(error)
        })
      });

      scope.selectClass = function(){
        language.resetAvilableOptions();
        eventManager.broadcast('student:selectClass', scope.selectedClass);
      }

      scope.$watch('selectedClass', function(val){
        if(val){
          scope.selectClass();
        }
      })

      scope.$watch('nav.selection', function(val){
        if(val){
          $rootScope.pageNav = val + '-nav';
          if(PlatformService.isPhonePortrait()){
            $rootScope.sidebarExpanded = false;
          }
        }
      });

      var betaTabs = [];

      var optionIdToTransId = {
        'modules': 14569,
        'dashboard': 27651
      }

      scope.getTranslation = function(option_id){
        var translationId = optionIdToTransId[option_id];
        if (translationId){
          return language.get(translationId);
        }
        else{
          return '';
        }
      }

      scope.getProperTranslation = function(id) {
        return language.get(id);
      }

      scope.isHiddenTab = function(option_id){
        return false;
      }

      scope.isBetaTab = function(option){
        if ( _.indexOf(betaTabs, option.id) !== -1 ){
          return true;
        }
        return false
      }

      scope.showPortraitModeWarning = true;
      scope.hidePortraidModeWarning = function() {
        scope.showPortraitModeWarning = false;
      }


      scope.getSidebarIcon = function(tabSlug){
        return 'assets/images/navbar/'+tabSlug+'.png';
      }

      function list_compare(item, list){
        var found = false;
        list.forEach( (this_class)=>{
          if(this_class.id === item.id){
            found = true;
          }
        })
        return found;
      }

      eventManager.listen('refresh:current:tab', function(e){
        scope.nav.resetSelection();
      })

      eventManager.listen('goto-module-tab', function(e, args){
        redirect_class = parseFloat(args);
      })

    }
  }
});
